import axios from "axios";

const env = require('./env');

export default axios.create({
	baseURL: env.REACT_APP_API_URL,
	headers: {
		"Accept": "application/json", 
	}
});